
// export const BASE_URL="http://54.252.165.71:8081"

//export const BASE_URL="http://localhost:8000/api/v1"
export const BASE_URL="https://bebshai-backend-app-754o5.ondigitalocean.app/api/v1"
export const API_ENDPOINT="http://localhost:8000"


export const PRODUCTION=false
